import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { boxTypesApi } from './box-types.api';
import type { BoxTypesListParams } from '../types';

export const boxTypeKeys = {
  all: ['box-types'] as const,
  lists: () => [...boxTypeKeys.all, 'list'] as const,
  list: (filters: BoxTypesListParams) =>
    [...boxTypeKeys.lists(), filters] as const,
  details: () => [...boxTypeKeys.all, 'detail'] as const,
  detail: (id: number) => [...boxTypeKeys.details(), id] as const
};

export const boxTypeQueries = {
  list: (filters: BoxTypesListParams = {}) =>
    queryOptions({
      queryKey: boxTypeKeys.list(filters),
      queryFn: () => boxTypesApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: boxTypeKeys.detail(id),
      queryFn: () => boxTypesApi.getById(id),
      enabled: id > 0
    })
};
